import { Box, Flex, Slide } from "@chakra-ui/react";
import { MAX_GRID_WIDTH } from "config/styleConsts";
import type { HeaderWrapperProps } from "../types";
import { useHeaderAnimation } from "../Header.hooks";

export const HeaderWrapper = ({ children, topBannerComponent, returningUsersNotification }: HeaderWrapperProps) => {
  const { slideStyles, navBoxShadow } = useHeaderAnimation();

  return (
    <>
      {returningUsersNotification}
      <Slide {...slideStyles}>
        {topBannerComponent}
        <Box width="full" boxShadow={navBoxShadow} backgroundColor="white">
          <Flex
            flexDir="column"
            maxW={{ base: "full", xl: MAX_GRID_WIDTH }}
            mx="auto"
            px={{ base: 4, xl: 0 }}
            py={4}
            as="nav"
            role="menubar"
          >
            {children}
          </Flex>
        </Box>
      </Slide>
    </>
  );
};
